import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export default class Nextbar extends Component {
  render() {
    return (
      
        <div>
        <nav className="navbar navbar-expand-lg bg-body-tertiary" data-bs-theme="dark">
  <div className="container-fluid">
    <Link className="navbar-brand" to="/">ResQzone</Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
       
      <li className="nav-item"><Link className="nav-link active" aria-current="page" to="/">Home</Link></li>
        
          <li className="nav-item"><Link className="nav-link active" aria-current="page" to="/emergancy">Emergency</Link></li>

          <li className="nav-item"><Link className="nav-link active" aria-current="page" to="/donate">Donate</Link></li>
          <li className="nav-item"><Link className="nav-link active" aria-current="page" to="/dfd">Google Map</Link></li>
          <li className="nav-item"><Link className="nav-link active" aria-current="page" to="/d">Nearby</Link></li>
          <li className="nav-item"><Link className="nav-link active" aria-current="page" to="/login">Login</Link></li>
        
      
    
      </ul>
   
    </div>
  </div>
</nav> </div> ) } }